import React from 'react';
import { Card, CardContent } from '../ui/card';

export const StatCard = ({ icon: Icon, label, value, subtext, color = 'gold' }) => (
  <Card className="stat-card border-0 shadow-sm">
    <CardContent className="pt-4 pb-4 px-4">
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-xs sm:text-sm text-muted-foreground font-medium truncate">{label}</p>
          <p className="text-xl sm:text-2xl font-semibold mt-0.5 truncate">{value}</p>
          {subtext && <p className="text-xs text-muted-foreground mt-0.5">{subtext}</p>}
        </div>
        <div className={`w-8 h-8 rounded-xl bg-${color}/10 flex items-center justify-center shrink-0 ml-2`}>
          <Icon className={`w-4 h-4 text-${color}`} />
        </div>
      </div>
    </CardContent>
  </Card>
);
